<template>
    <div class="p-3">
        <span class="text-xl mt-10 font-weight-black">تنظیمات</span>
        <v-card class="mt-5 p-10 pb-2 shadow">
            <v-row class="justify-center justify-sm-start">
                <v-col cols="4" sm="3">
                    <img v-if="profile.path" class="rounded w-full max-h-[200px]" :src="profile.path">
                    <div v-else  class="flex items-center justify-center h-full bg-stone-50">
                        <v-icon size="150" color="primary">mdi-account</v-icon>
                    </div>
                </v-col>
                <v-col cols="auto" sm="9">
                    <div class="flex items-center justify-center justify-sm-start">
                        <span class="text-xl font-bold ml-3 text-stone-600">{{ profile.factoryName }}</span>
                        <v-tooltip top max-width="250">
                            <template v-slot:activator="{ on, attrs }">
                                <button v-on="on" v-bind="attrs">
                                    <VIcon v-if="profile.verify" size="20" color="primary">mdi-check-decagram</VIcon>
                                </button>
                            </template>
                            <span class="text-[10px]">تایید احراز هویت</span>
                        </v-tooltip>
                    </div>
                    <div class="border border-dotted w-max mr-0 mr-sm-7 flex p-5 rounded flex-col items-center mt-3">
                        <span class="text-sm text-slate-400">کیف پول من</span>
                        <div class="flex items-center mt-3">
                            <!-- <i class="mdi ml-2 mdi-wallet text-green-500"></i> -->
                            <v-icon color="green" size="15" class="ml-2">mdi-wallet</v-icon>
                            <span class="text-xs"><b class="text-base">{{ Separate(wallet) }}</b> ریال</span>
                        </div>
                        <div class="flex items-center flex-wrap flex-sm-nowrap space-y-3 sm:space-y-0 justify-center mt-3">
                            <router-link :to="{name: 'payments'}">
                                <v-btn color="info" large class="ml-sm-3 w-full sm:w-max">
                                    <span>شارژ کیف پول</span>
                                </v-btn>
                            </router-link>
                            <v-btn color="info" large disabled class="w-full  sm:w-max">
                                <span>برداشت از کیف پول</span>
                            </v-btn>
                        </div>
                    </div>
                </v-col>
                <v-col cols="12" class="mt-5">
                    <div class="flex text-stone-500 items-center space-x-10 space-x-reverse">
                        <button @click="pageHandeler('profileFactory')" :class="[{'text-blue-500 border-b-blue-500' :navigarorValue === 'profileFactory'}, btnClass]">
                            <span class="text-base font-bold">پروفایل من</span>
                        </button>
                        <button @click="pageHandeler('editProfileFactory')" :class="[{'text-blue-500 border-b-blue-500' :navigarorValue === 'editProfileFactory'}, btnClass]">
                            <span class="text-base font-bold">ویرایش پروفایل</span>
                        </button>
                    </div>
                </v-col>
            </v-row>
        </v-card>
        <div class="content">
            <router-view></router-view>
        </div>
    </div>
</template>

<script>
import axiosApi from "@/plugins/axios";
import separate from "@/plugins/separate"

export default {
    name: 'profile',
    data() {
        return {
            wallet: 0,
            profile: '',
            navigarorValue: this.$route.name,
            btnClass: 'border-solid border-b-2 pb-1 border-transparent duration-200 hover:border-b-blue-500'
        }
    },
    methods: {
        pageHandeler(value){
            if (value !== this.navigarorValue) {
                this.navigarorValue = value
                this.$router.push({name: value})
            }
        },
        getProfile(){
            axiosApi().get('v2/factory/profile')
            .then(res => {
                this.profile = res.data.data.profile
                this.wallet = res.data.data.profile.wallet
            })
        },
        Separate(item){
            return separate(item)
        },
    },
    mounted(){
        this.getProfile()
    }
}
</script>

<style scoped>

</style>
